import { Document, Page, StyleSheet, Text, View, } from '@react-pdf/renderer';
import React, { useMemo } from 'react';

import { LETTER, PAGE_SIZES } from './RILabelDocument.constants';

const fontSize = 11.5;

const MultiRILabelDocument = ({
  vehicles,
  pageSize = LETTER,
  rotate = false,
}) => {
  const styles = useMemo(() => {
    return StyleSheet.create({
      page: {
        position: 'relative',
        fontFamily: 'Helvetica',
        textAlign: 'left',
        fontSize: fontSize,
        lineHeight: 1.2,
      },
      container: {
        position: 'absolute',
        flexDirection: 'column',
        padding: 6,
        transform: rotate ? 'rotate(270deg)' : 'rotate(0deg)',
        transformOrigin: 'top',
        width: rotate ? PAGE_SIZES[pageSize].height : '100%',
        left: rotate ? -PAGE_SIZES[pageSize].height / 2 : 0,
        top: rotate ? PAGE_SIZES[pageSize].height / 2 : 0,
        bottom: rotate ? -PAGE_SIZES[pageSize].height : 0,
      },
      row: {
        display: 'flex',
        flexDirection: 'row',
        // alignItems: 'start',
      },
      column: {
      },
      column15: {
        width: '15%',
      },
      column25: {
        width: '25%',
      },
      column50: {
        width: '50%',
      },
      bold: {
        fontFamily: 'Helvetica-Bold',
      },
      spacer: {
        marginTop: fontSize,
      },
      spacerSmall: {
        marginTop: fontSize / 4,
      },
      uppercase: {
        textTransform: 'uppercase',
      }
    });
  }, [pageSize, rotate]);
  const formatTireString = ({ tireType, treadWidth, aspectRatio, diameter, loadRating, speedRating }) => {
    return `${tireType || ''} ${treadWidth || ''}/${aspectRatio || ''} R${diameter || ''} ${loadRating || ''} ${speedRating || ''}`.trim();
  };
  return (
    <Document>
      <Page size={PAGE_SIZES[pageSize]} style={styles.page}>
        {vehicles.map((vehicle, index) => {
          return (
            <View key={index} style={styles.container} break={index !== 0}>
              <View style={styles.bold}>
                <Text>MANUFACTURED BY: {vehicle.manufacturer?.name || ''}</Text>
                <Text>IMPORTED BY: {vehicle.User.register_importer.companyName}</Text>
                <Text>
                  DATE OF MANUFACTURE:{' '}
                  {`${`0${vehicle.manufacturerMonth}`.slice(-2)}/${vehicle.manufacturerYear}`}
                </Text>
              </View>
              <View style={styles.spacer}></View>
              <View style={styles.row}>
                <View style={styles.column50}>
                  <Text style={styles.bold}>GVWR AND GAWR DATA:</Text>
                  <View style={styles.spacerSmall}></View>
                  <View style={styles.row}>
                    <View style={styles.column}>
                      <Text style={styles.bold}>GVWR: </Text>
                      <Text style={styles.bold}>GAWR FRONT: </Text>
                      <Text style={styles.bold}>GAWR REAR: </Text>
                    </View>
                    <View style={styles.column}>
                      <Text>{vehicle.GVWRKGS} kg ({vehicle.GVWRLBS} lb)</Text>
                      <Text>{vehicle.frontGAWRKGS} kg ({vehicle.frontGAWRLBS} lb)</Text>
                      <Text>{vehicle.rearGAWRKGS} kg ({vehicle.rearGAWRLBS} lb)</Text>
                    </View>
                  </View>
                </View>
                <View style={styles.column50}>
                  <Text style={styles.bold}>TIRE AND RIM DATA:</Text>
                  <View style={styles.spacerSmall}></View>
                  <Text>FRONT {vehicle.vehicleTireData.frontTireData} ON {vehicle.vehicleTireData.frontRimData}</Text>
                  <Text>COLD PSI {vehicle.vehicleTireData.frontColdTirePressurePSI} PSI ({vehicle.vehicleTireData.frontColdTirePressureKPA} kPa)</Text>
                  <View style={styles.spacerSmall}></View>
                  <Text>REAR {vehicle.vehicleTireData.rearTireData} ON {vehicle.vehicleTireData.rearRimData}</Text>
                  <Text>COLD PSI {vehicle.vehicleTireData.rearColdTirePressurePSI} PSI ({vehicle.vehicleTireData.rearColdTirePressureKPA} kPa)</Text>
                </View>
              </View>
              <View style={styles.spacer}></View>
              <View>
                <Text>
                  THIS VEHICLE CONFORMS TO ALL APPLICABLE U.S. FEDERAL MOTOR VEHICLE SAFETY, BUMPER AND THEFT PREVENTION STANDARDS IN EFFECT ON THE DATE OF MANUFACTURE SHOWN ABOVE.
                </Text>
              </View>
              <View style={styles.spacer}></View>
              <View style={styles.row}>
                <View style={styles.column50}>
                  <Text><Text style={styles.bold}>VIN: </Text>{vehicle.vin}</Text>
                </View>
                <View style={styles.column50}>
                  <Text style={styles.uppercase}><Text style={styles.bold}>TYPE: </Text>{vehicle.vehicleType || ''}</Text>
                </View>
              </View>
            </View>
          );
        })}
      </Page>
    </Document>
  );
};

export default MultiRILabelDocument;
